/**
 * Front - Widget Header Alerts.
 */

'use strict';

var helper = require('../misc/helpers');

var FrontWidgetHeaderAlerts = function () {
    $(document).ready((function() {
        if (!$('#header-alerts').length > 0) {
            return;
        }

        this.hideClosedNotice();
        this.closeNotice();
    }).bind(this));
};

FrontWidgetHeaderAlerts.prototype = {
    closeNotice: function() {
        $('#header-alerts .close-notice').on('click', function(e) {
            e.preventDefault();

            var $notice = $(this).closest('.notice');
            var id = $notice.attr('id');
            $notice.remove();

            helper.setCookie('hide_' + id, 'yes', 15*24); // Hide the notice for 15 days
        });
    },

    hideClosedNotice: function() {
        $('#header-alerts .notice').each(function() {
            var id = $(this).attr('id');
            var closeCookie = helper.getCookie('hide_' + id);
            if (closeCookie == 'yes') {
                $(this).remove();
            } else {
                $(this).show();
            }
        });
    },
};

module.exports = new FrontWidgetHeaderAlerts();
